import React, { Fragment } from 'react';
import showAlert from '../../../common/utils/alert';
import {
  environmentSwitchOptions,
  constructDeveloperApiDocsUrl,
} from '../../../common/utils/environments';
import EnvSetting from './EnvSetting';
import {
  Accordion,
  AccordionItem,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel,
  AccordionItemState,
} from 'react-accessible-accordion';
import { snakeCaseToTitleCase } from '../../../common/utils/api_utils';
export default function DevApiKey({
  projectDetail,
  projectId,
  version,
  developerApiDomain,
  actions,
  deleteFlag,
}) {
  const renderAccordionContent = (environment) => {
    return (
      <EnvSetting
        projectId={projectId}
        version={version}
        projectDetail={projectDetail}
        environment={environment}
        actions={actions}
        deleteFlag={deleteFlag}
      />
    );
  };

  const renderAccordion = () => {
    return environmentSwitchOptions.map((environment) => (
      <AccordionItem key={environment.value} uuid={environment.value}>
        <AccordionItemHeading>
          <AccordionItemButton>
            <span style={{ fontSize: '15px' }}>
              <i className={`webconnect webconnect-${environment.icon}`} />
              {environment.label} Environment
            </span>
          </AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>{renderAccordionContent(environment)}</AccordionItemPanel>
      </AccordionItem>
    ));
  };
  const developerApiDocsUrl = constructDeveloperApiDocsUrl(projectDetail.apiDomainName);
  return (
    <>
      <div className="row">
        <div className="col-md-2 col-lg-2 col-sm-2"></div>
        <div className="col-md-7 col-lg-7 col-sm-7 row d-flex align-items-end">
          <a
            href={developerApiDocsUrl}
            className="text-center text-underline font-weight-bolder"
            target="blank"
          >
            Developer API Documentation (Swagger UI)&nbsp;
            <i className="webconnect webconnect-box-arrow-up-right" />
          </a>
        </div>
      </div>
      <div className="row mt-2">
        <div className="col-md-1 col-lg-1"></div>
        <div className="col-md-10 col-lg-10 col-sm-12">
          <Accordion allowZeroExpanded preExpanded={['PREVIEW']}>
            {renderAccordion()}
          </Accordion>
        </div>
        <div className="col-md-1 col-lg-1"></div>
      </div>
    </>
  );
}
